// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zX2Y","content":"styles_content__2kmWE","row":"styles_row__3t6m4","footer":"styles_footer__ZjKZv","phraseLength":"styles_phraseLength__1P-kR"};